import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Options } from 'ng5-slider';
import { ApiService, EventEmitterService } from '../../services';
import { IFilterData } from '../../models/products-payload.interface';
import { Subscription } from 'rxjs';
import { FilterUtilService } from './filter-util.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-catalog-filters',
  templateUrl: './catalog-filters.component.html',
  styleUrls: ['./catalog-filters.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class CatalogFiltersComponent implements OnInit, OnDestroy {
  showLoader = false;
  filterErr = '';
  currentFilter: any;
  filterData: any;
  sliderOptions: Options = {
    step: 1,
  };
  priceFilter = {};
  widthFilter = {};
  heightFilter = {};
  lengthFilter = {};
  depthFilter = {};
  diameterFilter = {};

  diameter_from: any;
  diameter_to: any;
  width_from: any;
  width_to: any;
  height_from: any;
  height_to: any;
  length_from: any;
  length_to: any;
  depth_from: any;
  depth_to: any;
  price_from: any;
  price_to: any;
  originalFilterData: any;
  filteredElements: string[] = [];
  defaultFilters = ["color", "shape", "style"];
  style: string = "";
  filterKeys: any;
  orderedFilterData: any[] = [];
  sizeBackup: any;
  iscurrentFilterApplied: boolean;
  filterURL: any;
  subCategories: any[] = [];
  urlFilter: any;
  productFilters: IFilterData;
  category: string;
  filters = "";

  productFilter: any;
  storedFilterData: any;
  loadFilters: boolean;
  productsLoading: boolean;
  public Math: Math = Math;


  pageWidth: number;
  filterApiSubscription: Subscription;
  @Input() sortType = '';
  @Output() closeNav = new EventEmitter();
  @Output() emitFilters = new EventEmitter();
  @Input() keyword: string = '';
  @Input() keywordUrl: string = '';
  @Input() mode:string='';
  showAll = false;
  isHandset: boolean;
width:number;
filteredBrandOptions:any[]=[];
filteredCategoryOptions:any[]=[];
  searchCtrl = new FormControl('');
  searchCategoryCtrl = new FormControl('');
  brandsList: any[] = [];
  selectedBrands: any[] = [];
  selectedCategories: any[] = [];


  constructor(public api: ApiService, private filterUtil: FilterUtilService,
    private eventEmitterService: EventEmitterService,
     private activeRoute: ActivatedRoute) { }
  ngOnInit(): void {
        this.mySelect?.open();
        this.catSelect?.open();
        this.select = null;
        this.categorySelect = null;
       const id = JSON.parse(localStorage.getItem("user"))?.id;
    if (!id) {
      this.eventEmitterService.userChangeEvent.subscribe(() => {
        this.getParamsFromQuery();
      });
    } else {
      this.getParamsFromQuery();
    }
    this.isHandset = window.innerWidth < 600 ; 
    this.width = window.innerWidth;
        this.searchCtrl.valueChanges.subscribe(searchText => {
      const search = searchText.toLowerCase();
      this.filteredBrandOptions = this.brandsList?.filter(option =>
        option.name?.toLowerCase().includes(search) 
      );
    });

           this.searchCategoryCtrl.valueChanges.subscribe(searchText => {
      const search = searchText.toLowerCase(); 
      this.filteredCategoryOptions = this.subCategories?.filter(option =>
        option.name?.toLowerCase().includes(search)
      );
    });
  }

    ngOnDestroy() {
    this.eventEmitterService.userChangeEvent?.unsubscribe();
  }


  getParamsFromQuery(): void {
    this.activeRoute.queryParams.subscribe(
      (params) => {
        if (params) {
          this.filters = params.filters || "";
          this.urlFilter = JSON.parse(JSON.stringify(this.filters));
          this.filterURL = JSON.parse(JSON.stringify(this.filters));
        }
        if (this.filters) {
          const keys = this.filterUtil.extractKeys(this.filters);

          this.filteredElements = keys;
        }
        if (!this.filterUtil.filterPayload) {
          this.showLoader = true;
          this.getFiltersFromQuery();
        } else {
          this.processPayload(this.filterUtil.filterPayload);

        }
      }
    );
  }

  getFiltersFromQuery(): void {
    this.loadFilters = true;
    this.filters = this.formFilterURL();
    this.storedFilterData = this.deepClone(this.orderedFilterData);

    this.filterApiSubscription = this.api.getProductFilters(this.keyword, this.filters, '', this.keywordUrl, this.mode)
      .subscribe(
        (payload: any) => {
          this.filterUtil.filterPayload = JSON.parse(JSON.stringify(payload));
          this.processPayload(payload);
        },
        () => {
          this.filterErr = 'Filter data failed to load. Please try again or contact support for further assistance.';
          this.loadFilters = false;
        }
      );
  }

  processPayload(payload) {
    this.productFilters = payload.filterData;
    this.filterKeys = payload.filterKeys;
    this.filters = "";
    this.getFiltersData();
    // if (this.filterURL.includes('class')) {
    this.applyUrlFilters();
    this.getAvailableSubCategories();

    // } else {
    setTimeout(() => {
      this.applyUrlFilters();
      if(this.select){
        this.mySelect.open();
        this.select = null;
      }
      if(this.categorySelect){
        this.catSelect.open();
        this.categorySelect = null;
      }
    }, 100);

    // }


    this.showLoader = false;
    this.loadFilters = false;
  }

  private applyUrlFilters(): void {
    if (!this.filterURL) return;
    const pairedData = this.api.pairKeyValues(this.deepClone(this.urlFilter));

    const updated = pairedData.map(item =>
      item.key === 'category'
        ? { ...item, key: 'subcategory' }
        : item
    );
    updated.forEach(({ key, value }) => {
      if (this.productFilters[key] && key !== "size" && key !== "price") {

        if (key === 'subcategory') {
          this.productFilters[key].forEach((element: any) => {
            if (value?.join(',').includes(element?.category_id)) {
              element.checked = true;
            }
          });
        } else {
          value.forEach((v: any) => {
            this.productFilters[key].forEach((element: any) => {
              if (element.value === v || element?.category_id === v) {
                element.checked = true;
              }
            });
          });
        }
        if (key === 'brand') {
          this.selectedBrands = this.productFilters["brand"].filter(b => b.checked).map(b => b.value);
        }
        if (key === 'subcategory') {
          this.selectedCategories = this.productFilters["subcategory"].filter(b => b.checked).map(b => b.category_id);
        }


      }
    });
  }

  formFilterURL(): string {
    const ranges = ["price", "diameter", "width", "height", "length", "depth"];
    const rangeValues = {
      price_from: this.price_from, price_to: this.price_to,
      diameter_from: this.diameter_from, diameter_to: this.diameter_to,
      width_from: this.width_from, width_to: this.width_to,
      height_from: this.height_from, height_to: this.height_to,
      length_from: this.length_from, length_to: this.length_to,
      depth_from: this.depth_from, depth_to: this.depth_to
    };

    return this.filterUtil.buildFilterUrl(
      this.filteredElements,
      this.orderedFilterData,
      this.subCategories,
      ranges,
      rangeValues,
      this.filterData
    );
  }


  deepClone<T>(data: T): T {
    return data ? JSON.parse(JSON.stringify(data)) : data;
  }
  select: MatSelect;
  categorySelect: MatSelect;
  @ViewChild('mySelect') mySelect: MatSelect;
  @ViewChild('catSelect') catSelect: MatSelect;

  keepOpen(select: MatSelect) {
    this.select = select; 
}
keepOpenCategory(categorySelect: MatSelect) {
    this.categorySelect = categorySelect; 
}



  getFiltersData(): void {
    delete this.productFilters["diameter"];
    delete this.productFilters["square"];

    Object.keys(this.productFilters).forEach(k => {
      if (
        Array.isArray(this.productFilters[k]) &&
        (this.productFilters[k].length === 0 ||
          this.productFilters[k].every((e: any) => !e.enabled))
      ) {
        delete this.productFilters[k];
      }
    });

    this.storedFilterData = this.deepClone(this.orderedFilterData);
    this.orderedFilterData = [];

    for (const key of this.filterKeys) {
      const openedData = this.storedFilterData.find(f => f.key === key);
      let filterValue = this.productFilters[key];

      if (filterValue) {
        if (key === "bed_size") {
          const bedSizeOrder = ["Twin", "Full", "Queen", "King", "California King"];
          const orderMap = bedSizeOrder.reduce((map, name, i) => {
            map[name] = i;
            return map;
          }, {} as Record<string, number>);

          filterValue = filterValue.sort(
            (a: any, b: any) =>
              (orderMap[a.name] ?? Infinity) - (orderMap[b.name] ?? Infinity)
          );
        }

        this.orderedFilterData.push({
          key,
          value: filterValue,
          opened: openedData?.opened ?? false,
          showAll: openedData?.showAll ?? false,
        });
      }

      if (key === "class") {
        const openedSub = this.storedFilterData.find(f => f.key === "subcategory");
        this.orderedFilterData.push({
          key: "subcategory",
          value: this.subCategories,
          opened: openedSub?.opened ?? false,
          showAll: openedSub?.showAll ?? false,
        });

      // this.subCategories= this.productFilters["subcategory"]; 
      this.filteredCategoryOptions = JSON.parse(JSON.stringify(this.subCategories));
      }
          if(key=== "brand"){
            this.brandsList= this.productFilters["brand"];
      this.filteredBrandOptions = this.productFilters["brand"].filter(b=>b.enabled);
    }
      

      } 
         if (this.storedFilterData?.length) {
      this.orderedFilterData = this.api.compareAndUpdate(
        this.storedFilterData,
        this.orderedFilterData
      );
    }

    this.filterData = this.productFilters;
    this.originalFilterData = this.deepClone(this.filterData);

    this.sizeBackup = this.deepClone(this.productFilters["size"]);
    this.widthFilter = this.sizeBackup["width"];
    this.heightFilter = this.sizeBackup["height"];
    this.lengthFilter = this.sizeBackup["length"];
    this.depthFilter = this.sizeBackup["depth"];
    this.priceFilter = { ...this.productFilters["price"], name: "price" };

    const ranges = ["price", "diameter", "width", "height", "length", "depth"];
    const rangeValues = {
      price_from: this.price_from, price_to: this.price_to,
      diameter_from: this.diameter_from, diameter_to: this.diameter_to,
      width_from: this.width_from, width_to: this.width_to,
      height_from: this.height_from, height_to: this.height_to,
      length_from: this.length_from, length_to: this.length_to,
      depth_from: this.depth_from, depth_to: this.depth_to
    };

    const filterUrl = this.filterUtil.buildFilterUrl(
      this.filteredElements,
      this.orderedFilterData,
      this.subCategories,
      ranges,
      rangeValues,
      this.filterData
    );

    // If you want to persist this, uncomment:
    // this.urlFilter = filterUrl;

    this.loadFilters = false;

  }


  getAvailableSubCategories(): void {
    this.filters = this.formFilterURL();
    if (this.filters) {
      this.filterURL = this.deepClone(this.filters);
    }

    const selectedClasses = this.filterData["class"]?.filter(c => c.checked).map(c => c.value) || [];
    this.subCategories = [];

    const classesToCheck = selectedClasses.length ?
      this.filterData["class"].filter(c => selectedClasses.includes(c.value)) :
      this.filterData["class"];

    for (const c of classesToCheck || []) {
      for (const d of c.department || []) {
        const data = d.categories.filter((cat: any) => cat.enabled);
        this.subCategories = [...new Set([...this.subCategories, ...data])];
      }
    }

    this.productFilters["subcategory"] = this.subCategories;

    const classIndex = this.orderedFilterData.findIndex(f => f.key === "class");
    if (classIndex > -1) {
      const subIndex = this.orderedFilterData.findIndex(f => f.key === "subcategory");
      if (subIndex > -1) {
        this.orderedFilterData[subIndex].value = this.subCategories;
      } else {
        this.orderedFilterData.splice(classIndex + 1, 0, {
          key: "subcategory",
          value: this.subCategories,
          opened: false,
          showAll: false,
        });
      }
      this.filteredCategoryOptions = JSON.parse(JSON.stringify(this.subCategories));

    }
  }


  private updateFilterState(name: string, isChecked: boolean, optionName?: string) {

    this.currentFilter = name;

    // Update productFilters
    this.productFilters[name].forEach(opt => {
      if (!optionName || opt.name === optionName) {
        opt.checked = isChecked;
      }
    });

    // Update orderedFilterData
    const section = this.orderedFilterData.find(f => f.key === name);
    if (section) {
      section.value.forEach(opt => {
        if (!optionName || opt.name === optionName) {
          opt.checked = isChecked;
        }
      });
    }



    // Maintain filteredElements list
    const hasChecked = this.productFilters[name].some(opt => opt.checked);
    this.filteredElements = hasChecked
      ? Array.from(new Set([...this.filteredElements, name]))
      : this.filteredElements.filter(f => f !== name);

    this.filterApiSubscription?.unsubscribe();
  }

  private refreshFilters(name: string) {
    // const isCategory = name === 'class' || name === 'subcategory';

    // if (name === 'class') {
    //   this.getAvailableSubCategories();
    // }

    if (this.filterApiSubscription) {
      this.filterApiSubscription.unsubscribe();
    }


    const filterData = this.formFilterURL();
    this.filters = filterData;
    this.urlFilter = this.filters;

    if (this.filters) {
      this.filterURL = JSON.parse(JSON.stringify(this.filters));
    } else {
      this.filterURL = '';
    }
    this.getFiltersFromQuery();

    this.applyFilter();

    this.iscurrentFilterApplied = true;
  }

  selectFilter(option: any, name: string, event?: Event) {
    console.log('option', option, name);
    if (event) { event.preventDefault(); }

    if (name !== 'color') {
      option.checked = !option.checked;
    }



    this.updateFilterState(name, option.checked, option.name);
    this.refreshFilters(name);
 
  }

  brandSelectChange(event:any){
    if (event) { event.preventDefault(); }
  }
  // selectAll(name: string) {
  //   this.updateFilterState(name, true);
  //   this.refreshFilters(name);
  //   if(name==="brand"){
  //     this.selectedBrands= this.productFilters["brand"].map(b=>b.value);
  //   }
  // }

  unSelectAll(name: string) {
    this.updateFilterState(name, false);
    this.refreshFilters(name);
       if(name==="brand"){
      this.selectedBrands= [];//this.productFilters["brand"].map(b=>b.value);
    } 
    if(name==="subcategory"){
      this.selectedCategories= [];//this.productFilters["subcategory"].map(b=>b.category_id);
    }
  }



  displayedItems(o): string[] {
    let value = o.value.filter(f => f.enabled);
    return o.showAll ? value : value.slice(0, 12);
  }
  enabledLength(o): number {
    let value = o.value.filter(f => f.enabled);
    return value.length;
  }
  toggleItems(o): void {
    o.showAll = !o.showAll;
  }


  getCheckedLength(name): boolean {
    return this.filterData[name].filter((f) => f.checked).length > 0;
  }
  getSelections(name): string {
    return this.filterData[name]
      .filter((f) => f.checked)
      .map((f) => f.name)
      .join(",");
  }
  clearSelections(name) {
    this.filterData[name].forEach((element) => {
      element.checked = false;
    });
    this.filteredElements = this.filteredElements.filter((f) => f != name);
    this.applyFilter();
  }




  close() {
    this.closeNav.emit();
  }
  getValue(key) {
    return key.replace(/[_-]/g, ' ').toUpperCase();
  }
  collapSection(o: any) {
    o.opened = !o.opened;
  }


  showClear(key) {
    if (this.filterData[key] && this.filterData[key].length > 0) {
      return this.filterData[key].some((f) => f.checked);
    } else {
      return false;
    }
  }
  clearSize() {
    this.iscurrentFilterApplied = false;
    this.sizeBackup = JSON.parse(JSON.stringify(this.originalFilterData['size']));
    ['width', 'height', 'length', 'depth'].forEach(dim => {
      this[`${dim}Filter`] = this.sizeBackup[dim];
    });

    ['diameter', 'width', 'height', 'length', 'depth'].forEach(dim => {
      this[`${dim}_from`] = null;
      this[`${dim}_to`] = null;
    });

    this.filteredElements = [];
    this.filterURL = '';
    this.filterErr = '';

    this.filters = this.formFilterURL();
    this.productsLoading = true;
    this.getFiltersFromQuery();
  }


  resetFilter() {
    this.filterData = JSON.parse(JSON.stringify(this.originalFilterData));

    const checkKeys = [
      'brand', 'class', 'color', 'subcategory', 'country',
      'designer', 'style', 'seating', 'shape'
    ];
    checkKeys.forEach(key => this.clearChecked(key));

    if (this.originalFilterData['class']) {
      this.filterData['class'] = JSON.parse(JSON.stringify(this.originalFilterData['class']));
    }

    this.orderedFilterData.forEach(section => {
      section.showAll = false;
      if (Array.isArray(section.value)) {
        section.value.forEach(opt => opt.checked = false);
      }
    });

    this.iscurrentFilterApplied = false;

    this.sizeBackup = JSON.parse(JSON.stringify(this.originalFilterData['size']));
    ['width', 'height', 'length', 'depth'].forEach(dim => {
      this[`${dim}Filter`] = this.sizeBackup[dim];
    });
    if (this.productFilters['price']) {
      this.priceFilter = this.productFilters['price'];
      // this.priceFilter.name = 'price';
    }

    ['diameter', 'width', 'height', 'length', 'depth', 'price'].forEach(k => {
      this[`${k}_from`] = null;
      this[`${k}_to`] = null;
    });

    // General state reset
    this.filteredElements = [];
    this.filterURL = '';
    this.subCategories = [];
    this.filterErr = '';
        this.selectedBrands= [];
        this.selectedCategories = [];

    this.uncheckAllItems(this.filterData['class']);

    this.filterApiSubscription?.unsubscribe();
    this.filters = this.formFilterURL();
    this.getFiltersFromQuery();
    this.emitFilters.emit('');
  }

  private clearChecked(key: string) {
    if (Array.isArray(this.filterData[key])) {
      this.filterData[key].forEach(f => f.checked = false);
    }
  }

  uncheckAllItems(data: any[]) {
    data?.forEach((category: any) => {
      Object.keys(category).forEach((key: string) => {
        if (Array.isArray(category[key])) {
          category[key].forEach((item: any) => {
            item.checked = false;

            Object.keys(item).forEach((it: string) => {
              if (Array.isArray(item[it])) {
                item[it].forEach((em: any) => {
                  em.checked = false;
                });
              }
            });
          });
        }
      });
    });
  }

  assignSliderData(event: { minValue: number; maxValue: number }, name: string) {
    this.currentFilter = name;

    const rangeKeys = ['diameter', 'width', 'height', 'length', 'depth', 'price'];

    if (rangeKeys.includes(name)) {
      this[`${name}_from`] = event.minValue;
      this[`${name}_to`] = event.maxValue;
    }
  }


  submitSlider(event, name) {
    this.assignSliderData(event, name)
    if (!this.filteredElements.includes(name)) {
      this.filteredElements.push(name);
    }

    this.filterApiSubscription?.unsubscribe();
    this.iscurrentFilterApplied = true;
    this.getFiltersFromQuery();
    this.applyFilter();
  }

  applyFilter() {
    const filterUrl = this.formFilterURL();
    this.emitFilters.emit(filterUrl);
  }
}

